import { useMemo } from 'react';
import { SlotType } from 'services/slotOrchestration/types';
import { useTrolley } from 'contexts/Trolley';
import { useSlotContext } from 'contexts/Slot';

export function useMinSpend() {
  const { state: trolleyState } = useTrolley();
  const {
    slotContext: { details: slotDetails },
  } = useSlotContext();

  const { slotType = SlotType.UNDEFINED } = slotDetails || {};
  const collectionMinimumOrderValue =
    trolleyState?.trolley?.trolleyTotals?.collectionMinimumOrderValue?.amount;
  const deliveryMinimumOrderValue =
    trolleyState?.trolley?.trolleyTotals?.deliveryMinimumOrderValue?.amount;

  const mimiumSpendThresholdMet = trolleyState?.trolley?.trolleyTotals?.minimumSpendThresholdMet;

  const showMinSpend = useMemo(
    () =>
      mimiumSpendThresholdMet !== undefined &&
      !mimiumSpendThresholdMet &&
      slotType !== SlotType.ENTERTAINING_COLLECTION &&
      slotType !== SlotType.UNDEFINED,
    [mimiumSpendThresholdMet, slotType],
  );

  const minSpend = useMemo(() => {
    let minimumSpend = 0;

    if (slotType === SlotType.DELIVERY && deliveryMinimumOrderValue) {
      minimumSpend = deliveryMinimumOrderValue;
    } else if (slotType === SlotType.GROCERY_COLLECTION && collectionMinimumOrderValue) {
      minimumSpend = collectionMinimumOrderValue;
    }
    return minimumSpend;
  }, [collectionMinimumOrderValue, deliveryMinimumOrderValue, slotType]);

  return {
    minSpend,
    showMinSpend,
  };
}
